import { BannerId } from '../../../typings/banners';
import { GroupId } from '../../../typings/groups';

export const ADD_NEW_INTERNAL_BANNER = 'ADD_NEW_INTERNAL_BANNER';
export type ADD_NEW_INTERNAL_BANNER = typeof ADD_NEW_INTERNAL_BANNER;

export interface AddNewInternalBanner {
    type: ADD_NEW_INTERNAL_BANNER;
    bannerId: BannerId;
    groupId: GroupId;
}

export function addNewInternalBannerAction(bannerId: BannerId, groupId: GroupId): AddNewInternalBanner {
    return {
        type: ADD_NEW_INTERNAL_BANNER,
        bannerId,
        groupId
    };
}
